import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ConfirmedSvg, InfoSvg } from 'src/assets/index';
import { DATE_FORMAT_DAY_MONTH, Routes } from 'src/constants/index';
import { BlueButton } from 'src/components/components/index';
import { formatDateCheckInOut } from 'src/utils/index';
import { RootState } from 'src/store';
import { setIsUpdateMenu, IMenuState, IReviewBookState } from 'src/store/slices/index';
import { CancellationPolicies } from '../../review-book/cancellation-policies';
import './style.scss';

interface IMapStateToProps {
  menuStore: IMenuState;
}

interface IMapDispatchToProps {
  setIsUpdateMenu: (value: boolean) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps {
  packageData: IReviewBookState;
  isBookingComplete: boolean;
  onClick?: () => void;
}

const ZERO = 0;

export class BookingConfirmedComponent extends React.Component<IProps, null> {
  nameMainGuest = (): string => {
    return this.props.packageData.guests.find((guest) => guest.isMainGuest === true).givenName;
  };

  updateMenu = (): void => {
    this.props.setIsUpdateMenu(true);
  };

  render(): React.ReactNode {
    const { packageData, isBookingComplete, onClick } = this.props;
    const nameHotel = packageData.bookingSummary.bookingCard.name;
    const startDate = packageData.bookingSummary.bookingCard.checkIn;

    return (
      isBookingComplete &&
      packageData.booking && (
        <div className="booking-confirmed">
          <ConfirmedSvg />
          <p className="booking-confirmed__title-info">
            <FormattedMessage id="thank.you" />, {this.nameMainGuest()}!
          </p>
          <p className="booking-confirmed__title">
            <FormattedMessage id="your.booking.in" /> {nameHotel}{' '}
            <FormattedMessage id="is.confirmed" />.
          </p>
          <p className="booking-confirmed__description">
            <span className="booking-confirmed__description_item">{nameHotel} </span>
            <FormattedMessage id="is.expecting.you.on" />{' '}
            <span className="booking-confirmed__description_item">
              {formatDateCheckInOut(startDate, DATE_FORMAT_DAY_MONTH)}
            </span>
          </p>
          <p className="booking-confirmed__number-info">
            <FormattedMessage id="confirmation.number" />:{' '}
            <span className="booking-confirmed__number">
              {packageData.booking.confirmationCode}
            </span>
          </p>
          <p className="booking-confirmed__instructional-text">
            <InfoSvg />
            <FormattedMessage id="you.may.be.asked" />
          </p>
          <p className="booking-confirmed__number-info">
            <FormattedMessage id="booking.code" />:{' '}
            <span className="booking-confirmed__number">
              {packageData.booking.hotelSegments[ZERO].orderId}
            </span>
          </p>
          <p className="booking-confirmed__instructional-text">
            <InfoSvg />
            <FormattedMessage id="you.may.need.this.number" />
          </p>
          <p className="booking-confirmed__number-info">
            <FormattedMessage id="member.ID" />:{' '}
            <span className="booking-confirmed__number">{packageData.booking.memberId}</span>
          </p>
          <CancellationPolicies />
          <p className="booking-confirmed__contact-property">
            <FormattedMessage id="contact.property" />:{' '}
            <span className="booking-confirmed__contact-property-phone">
              {packageData.booking.resortAddress.phone}
            </span>
          </p>
          <p className="booking-confirmed__contact-property">
            <FormattedMessage id="support" />:{' '}
            <span className="booking-confirmed__contact-property-phone">
              {packageData.booking.customerServiceNumber}
            </span>
          </p>
          <div className="booking-confirmed__btn-wrapper">
            <BlueButton onClick={onClick}>
              <FormattedMessage id="book.one.more.room" />
            </BlueButton>
            <Link to={`${Routes.Search}${location.search}`} onClick={this.updateMenu}>
              <BlueButton>
                <FormattedMessage id="search.hotel" />
              </BlueButton>
            </Link>
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = { setIsUpdateMenu };

export const BookingConfirmed = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BookingConfirmedComponent);
